export default "__VITE_ASSET__DnmIDRUD__"